// Matches anything on a print screen that is still loading. Gadgets show a
// CardSkeleton (data-testid="skeleton") while their data loads — not the
// Loading spinner — and a whole canvas shows CanvasLoading until its
// definitions resolve, so checking for spinners alone captures half-loaded
// reports. Mirrored in tools/report-renderer/src/renderReport.ts (a separate
// package); keep the two in sync.
const PRINT_LOADING_SELECTOR = [
  '[data-testid="loading"]',
  '[data-testid="skeleton"]',
  '[data-testid="canvas-loading"]',
].join(', ');

export default PRINT_LOADING_SELECTOR;
